import React, { useState } from "react";
import "./LandingPage1.css";
import { Link } from "react-router-dom";
import SubscriptionPlans from "../SubscriptionPlans/SubscriptionPlans";

const LandingPage1 = ({ videoLinks }) => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  return (
    <div className="body-bg">
      <header className="container1 header1">
        <a href="#" className="logo">Shutter</a>
        <nav className="nav-links">
          <Link to="/use-cases">Use Cases</Link>
          <Link to="/pricing">Pricing</Link>
        </nav>
        <div className="spacer" />
        <a href="/webapp" className="login-btn">Login</a>
      </header>

      <main className="container1">
        <section className="hero-section">
          <div className="hero-text">
            <h1 className="hero-heading">
              Photorealistic<div className="highlighted-text">Furniture Images</div><br/>in Seconds with AI
            </h1>
            <p className="hero-subtext">
              Our AI helps furniture brands save thousands on photography and rendering—while producing magazine-ready visuals in minutes.
            </p>
            <div className="hero-buttons">
              <a href="https://api.leadconnectorhq.com/widget/booking/q47rHzIRXjxEby7Q2zqi" target="_blank" rel="noopener noreferrer" className="demo-btn" style={{marginTop: 'auto', marginBottom: 'auto'}}>Book a Demo</a>
              <a href="/webapp" className="credit-btn" style={{marginTop: 'auto', marginBottom: 'auto'}}>
                🪙 Claim 100 Free Credits
              </a>
            </div>
          </div>
          <div className="hero-image" style={{ filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2))' }}>
            {/* <img
              src="https://storage.googleapis.com/a1aa/image/7e03d210-884c-49bf-f94a-98d396df2694.jpg"
              alt="Photorealistic brown leather armchair with wooden legs on beige background"
              loading="lazy"
            /> */}
            <video 
              src={videoLinks.hero}
              autoPlay
              loop
              muted
              playsInline
              className="hero-video"
              alt="Furniture showcase video"
              loading="lazy"
            />
          </div>
        </section>
      </main>

      <footer className="footer">
        <span>🖤 by more than 450+ customers from 16 countries</span>
      </footer>

      {/* Subscription Plans Modal */}
      {showSubscriptionModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl" onClick={() => setShowSubscriptionModal(false)}></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={() => setShowSubscriptionModal(false)}
                  >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <SubscriptionPlans readOnly={true} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage1;
